import type { CalidadControlModificacion } from "../../../types/control-modificaciones";

export type CalidadPlanificacionDeCambio = {
  id: number;
  fecha_planificacion: string | null;
  input_consecuencias_sistema: string | null;
  acciones: string | null;
  responsable: string | null;
  recursos: string | null;
  fecha_prevista: string | null;
  estado: string | null;
  acciones_realizadas_seguimiento: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type CalidadPlanificacionDeCambioPayload = {
  fecha_planificacion: string | null;
  input_consecuencias_sistema: string | null;
  acciones: string | null;
  responsable: string | null;
  recursos: string | null;
  fecha_prevista: string | null;
  estado: string | null;
  acciones_realizadas_seguimiento: string | null;
};

export type CalidadPlanificacionDeCambiosFilters = {
  search: string;
  estado: string;
  fecha_desde: string;
  fecha_hasta: string;
};

export type CalidadPlanificacionDeCambiosResponse = {
  data: CalidadPlanificacionDeCambio[];
  control_modificaciones: CalidadControlModificacion[];
  meta: {
    total: number;
    control_modificaciones: number;
    estados: string[];
  };
};

export const defaultPlanificacionCambiosFilters: CalidadPlanificacionDeCambiosFilters = {
  search: "",
  estado: "",
  fecha_desde: "",
  fecha_hasta: "",
};

export function createEmptyPlanificacionCambioForm(): CalidadPlanificacionDeCambioPayload {
  return {
    fecha_planificacion: null,
    input_consecuencias_sistema: "",
    acciones: "",
    responsable: "",
    recursos: "",
    fecha_prevista: "",
    estado: "",
    acciones_realizadas_seguimiento: "",
  };
}

export function mapPlanificacionCambioToPayload(
  row: CalidadPlanificacionDeCambio,
): CalidadPlanificacionDeCambioPayload {
  return {
    fecha_planificacion: row.fecha_planificacion,
    input_consecuencias_sistema: row.input_consecuencias_sistema ?? "",
    acciones: row.acciones ?? "",
    responsable: row.responsable ?? "",
    recursos: row.recursos ?? "",
    fecha_prevista: row.fecha_prevista ?? "",
    estado: row.estado ?? "",
    acciones_realizadas_seguimiento: row.acciones_realizadas_seguimiento ?? "",
  };
}
